import React from "react";
import PropTypes from "prop-types";
import { CloseIcon } from "../Icons";
import { Image } from "@learningblocks/shared-components/lib/Image";
import { isActivationKey } from "@learningblocks/shared-components";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import "./style.scss";

/**
 * The close button to be displayed with Modal Window
 */
export function CloseButton(props) {
  const keyDown = (event) => {
    if (isActivationKey(event)) {
      event.preventDefault();
      props.close(event);
    }
  };
  return (
    <div className={`closeButton-block ${props.className}`}>
      <span
        tabIndex="0"
        role="button"
        className={props.size}
        onKeyDown={keyDown}
        onClick={props.close}
      >
        <FormattedMessage string="Close" description="Close button label" />
        <Image
          className="closeButton"
          src={CloseIcon}
          aria-label={FormattedMessage({ string: "Close button" })}
          alt={FormattedMessage({ string: "Close button" })}
        />
      </span>
    </div>
  );
}

CloseButton.propTypes = {
  /**
   * custom className to set for closeButton
   */
  className: PropTypes.string.isRequired,
  /**
   * callback function to be involked close button is clicked
   */
  close: PropTypes.func,
  /**
   * String value to specify the size of modal
   */
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};

CloseButton.defaultProps = {
  className: "",
  size: "sm",
};
